export default "__VITE_ASSET__27b8722b__"